import { FC } from "react";
import { useIntl } from "react-intl";

export interface MailToCustomerServiceProps {
  subject?: string;
}

const MailToCustomerService: FC<MailToCustomerServiceProps> = ({
  children,
  subject,
}) => {
  const intl = useIntl();
  const emailAddress = intl.formatMessage({
    id: "customerServiceEmail",
    defaultMessage: "asiakaspalvelu@vastuugroup.fi",
  });
  return (
    <a
      href={`mailto:${emailAddress}${subject ? `?subject=${subject}` : ""}`}
      id="customerSupportLink"
    >
      {children}
    </a>
  );
};

export default MailToCustomerService;
